document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-nav-toggle]');
  const panel = document.querySelector('[data-nav-panel]');

  if (toggle && panel) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      panel.classList.toggle('is-open');
    });
  }

  document.querySelectorAll('form.form-card').forEach((form) => {
    form.addEventListener('submit', (event) => {
      const widget = form.querySelector('.cf-turnstile');

      if (!widget) {
        return;
      }

      const token = form.querySelector('input[name="cf-turnstile-response"]');
      let notice = form.querySelector('[data-turnstile-notice]');

      if (token && token.value) {
        if (notice) {
          notice.remove();
        }

        return;
      }

      event.preventDefault();

      if (!notice) {
        notice = document.createElement('p');
        notice.className = 'form-notice form-notice--error';
        notice.setAttribute('data-turnstile-notice', '');
        notice.setAttribute('role', 'alert');
        widget.insertAdjacentElement('afterend', notice);
      }

      notice.textContent = widget.getAttribute('data-pending-message') || 'Please complete the security check.';
    });
  });

  const caseForms = document.querySelectorAll('[data-case-form]');

  caseForms.forEach((form) => {
    const conditionalFields = form.querySelectorAll('[data-case-conditional-field]');

    if (!conditionalFields.length) {
      return;
    }

    const getFieldValue = (fieldName) => {
      const controls = form.querySelectorAll(`[name="${fieldName}"]`);

      if (!controls.length) {
        return '';
      }

      const radio = Array.from(controls).find((control) => control.checked);

      if (radio) {
        return radio.value;
      }

      return controls[0].value;
    };

    const updateConditionalFields = () => {
      conditionalFields.forEach((field) => {
        const conditionField = field.getAttribute('data-case-conditional-field');
        const conditionValue = field.getAttribute('data-case-conditional-value') || '';
        const isActive = getFieldValue(conditionField) === conditionValue;

        field.hidden = !isActive;

        field.querySelectorAll('input, select, textarea').forEach((control) => {
          control.disabled = !isActive;

          if (!isActive) {
            if (control.type === 'radio' || control.type === 'checkbox') {
              control.checked = false;
            } else {
              control.value = '';
            }
          }
        });
      });
    };

    form.addEventListener('change', updateConditionalFields);
    updateConditionalFields();
  });
});
